<ng-container *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <ng-container *ngIf="activityType?.sync_with_microsoft_365 === '1'">
            <tt-toast *ngIf="account !== undefined" [ttType]="!!account ? 'success' : 'danger'">
                <span title>
                    <ng-container *ngIf="!account">
                        <span ttTranslateWord="custactedit_mgt_not_logged_in"></span>.
                        <a href="" (click)="$event.preventDefault(); graphAuth.signIn()"><span ttTranslateWord="click_her_to_sign_in"></span>.</a>
                    </ng-container>
                    <span *ngIf="!!account" ttTranslateWord="custact_edit_custacts_will_be_added_to_calendar"></span>
                </span>
            </tt-toast>
            <hr class="col-xs-12 sp-0 k-hr" />
        </ng-container>
        <tt-input *ngIf="get.is_deviation === '1'" ttLabel="deviation_no" [(ttModel)]="get.deviation_no" ttReadonly></tt-input>
        <tt-input *ngIf="'' + get.custact_no_belongto > '0'" ttLabel="custact_no_belongto" [ttModel]="get.custact_no_belongto + ' ' + get.custact_note_belongto" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="workdetails" [ttGotoParms]="{ custact_no: get.custact_no_belongto }"></tt-form-field-button>
        </tt-input>
        <tt-input *ngIf="get.show_projectactivitytype_id === '1'" ttLabel="projectactivitytype_id" [(ttModel)]="get.projectactivitytype_id"></tt-input>
        <tt-select
            ttRequired
            ttLabel="activitytype"
            [(ttModel)]="get.activitytype_no"
            (ttModelChange)="onActivityTypeChanged()"
            [ttData]="activityTypes"
            ttDataId="activitytype_no"
            ttDataName="activitytype_name"
        ></tt-select>

        <ng-container *ngIf="get.is_deviation === '1'">
            <tt-input ttLabel="registered_of_labour_name" [(ttModel)]="get.regof_labour_name" ttReadonly></tt-input>
            <tt-date ttLabel="deviation_date" [(ttModel)]="get.deviation_date"></tt-date>
        </ng-container>

        <tt-datetime *ngIf="!!activityType && activityType.show_datetime_start === '1'" ttLabel="start" [(ttModel)]="get.datetime_start"></tt-datetime>
        <tt-datetime *ngIf="!!activityType && activityType.show_datetime_end === '1'" ttLabel="end" [(ttModel)]="get.datetime_end"></tt-datetime>
        <tt-checkbox ttLabel="has_deadline" [(ttModel)]="get.has_deadline"></tt-checkbox>

        <div [hidden]="get.has_deadline === '0'">
            <tt-date ttLabel="deadline" [(ttModel)]="get.deadline"></tt-date>
            <tt-select *ngIf="get.show_recurring === '1'" ttLabel="recurring" [(ttModel)]="get.recurring" [ttData]="recurrenceOptions" ttDataId="recurring_id" ttDataName="recurring_name"></tt-select>
        </div>

        <ng-container *ngIf="!!activityType && activityType.show_cust_no === '1'">
            <tt-input ttLabel="cust_no" [(ttModel)]="get.cust_no" ttReadonly>
                <tt-form-field-button buttons *ngIf="+get.cust_no > 0" ttIcon="fas fa-chevron-right" ttGoto="customersmenu" [ttGotoParms]="{ cust_no: '' + get.cust_no }"></tt-form-field-button>
            </tt-input>
            <tt-search ttLabel="cust_name" [(ttModel)]="get.cust_name" [ttSearch]="searchCustomers" (ttOnSelected)="onCustomerSelected($event)" (ttOnClear)="onCustomerSelected()"></tt-search>
        </ng-container>

        <tt-search
            *ngIf="!!activityType && activityType.show_serviceobject_keyno === '1'"
            ttLabel="serviceobject_name"
            [(ttModel)]="get.serviceobject_name"
            [ttSearch]="searchServiceObjects"
            (ttOnSelected)="onServiceObjectSelected($event)"
            (ttOnClear)="onServiceObjectSelected()"
        ></tt-search>
        <tt-select
            *ngIf="!!activityType && activityType.show_project_keyno === '1'"
            ttLabel="project_name"
            [(ttModel)]="get.project_keyno"
            (ttModelChange)="onProjectChanged()"
            [ttData]="projects"
            ttDataId="project_keyno"
            ttDataName="project_name"
        ></tt-select>
        <tt-select
            *ngIf="!!activityType && activityType.show_projectprosess_keyno === '1'"
            ttLabel="projectprosess"
            [(ttModel)]="get.projectprosess_keyno"
            [ttData]="projectProcesses"
            ttDataId="projectprosess_keyno"
            ttDataName="projectprosess_name"
        ></tt-select>
        <tt-search
            *ngIf="get.show_initiated_by_person === '1'"
            ttLabel="initiated_by_person_name"
            [(ttModel)]="get.initiated_by_person_name"
            [ttSearch]="searchPersons"
            (ttOnSelected)="onInitiatedBySelected($event)"
            (ttOnClear)="onInitiatedBySelected()"
        ></tt-search>
        <tt-search
            *ngIf="!!activityType && activityType.show_responsible_labour_no === '1'"
            ttLabel="responsible_labour"
            [(ttModel)]="get.responsible_labour_name"
            [ttSearch]="searchLabourers"
            (ttOnSelected)="onResponsibleLabourerSelected($event)"
            (ttOnClear)="onResponsibleLabourerSelected()"
        ></tt-search>
        <tt-input *ngIf="!!activityType && activityType.show_responsible_user_id === '1'" ttLabel="responsible_user" [(ttModel)]="get.responsible_user_id"></tt-input>
        <tt-select
            *ngIf="!!activityType && activityType.show_equipment_id === '1'"
            ttLabel="equipment"
            [(ttModel)]="get.equipment_id"
            [ttData]="equipments"
            ttDataId="item_id"
            ttDataName="item_name"
        ></tt-select>
        <tt-search
            *ngIf="!!activityType && activityType.show_order_order_no === '1'"
            ttLabel="order_order_no"
            [(ttModel)]="get.order_order_no"
            [ttSearch]="searchOrders"
            (ttOnSelected)="onOrderSelected($event)"
            (ttOnClear)="onOrderSelected()"
        ></tt-search>
        <tt-input ttLabel="order_internal_no" [(ttModel)]="get.order_internal_no" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="orderhead" [ttGotoParms]="{ order_internal_no: get.order_internal_no }"></tt-form-field-button>
        </tt-input>
        <tt-textarea ttLabel="job_description" [(ttModel)]="get.note" ttRequired></tt-textarea>
        <tt-select
            *ngIf="!!activityType && activityType.show_actstatus_keyno === '1'"
            ttLabel="actstatus"
            [(ttModel)]="get.actstatus_keyno"
            (ttSelect)="onActivityStatusSelected($event)"
            [ttData]="activityStatuses"
            ttDataId="actstatus_keyno"
            ttDataName="actstatus_name"
        ></tt-select>
        <tt-textarea *ngIf="get.custact_no === '0'" ttLabel="first_dialogue" [(ttModel)]="get.first_dialogue"></tt-textarea>

        <ng-container *ngIf="get.is_deviation === '1'">
            <tt-select
                ttLabel="deviationtype"
                [(ttModel)]="get.deviationtype_keyno"
                (ttModelChange)="onDeviationTypeChanged()"
                [ttData]="deviationTypes"
                ttDataId="deviationtype_keyno"
                ttDataName="deviationtype_name"
            ></tt-select>
            <tt-select
                ttLabel="deviationsource"
                [(ttModel)]="get.deviationsource_keyno"
                (ttModelChange)="onDeviationSourceChanged()"
                [ttData]="deviationSources"
                ttDataId="deviationsource_keyno"
                ttDataName="deviationsource_name"
            ></tt-select>
            <tt-select ttLabel="deviationsource2" [(ttModel)]="get.deviationsource2_keyno" [ttData]="deviationSources2" ttDataId="deviationsource_keyno" ttDataName="deviationsource_name"></tt-select>
        </ng-container>

        <tt-textarea *ngIf="!!activityType && activityType.show_solution_proposal === '1'" ttLabel="solution_proposal" [(ttModel)]="get.solution_proposal"></tt-textarea>
        <tt-textarea *ngIf="!!activityType && activityType.show_solution_note === '1'" ttLabel="solution_note" [(ttModel)]="get.solution_note"></tt-textarea>
        <tt-textarea *ngIf="!!activityType && activityType.show_solution_note_preventive === '1'" ttLabel="solution_note_preventive" [(ttModel)]="get.solution_note_preventive"></tt-textarea>
        <tt-search
            *ngIf="!!activityType && activityType.show_prod_id === '1'"
            ttLabel="product"
            [(ttModel)]="get.prod_keyname"
            [ttSearch]="searchProducts"
            ttDataId="prod_keyname"
            ttDataName="prod_keyname"
            (ttOnSelected)="onProductSelected($event)"
            (ttOnClear)="onProductSelected()"
        ></tt-search>
        <tt-checkbox ttLabel="ok" [(ttModel)]="get.ok"></tt-checkbox>

        <ng-container *ngIf="get.is_sales_opportunity === '1'">
            <tt-select ttLabel="sales_size" [(ttModel)]="get.sales_size_no" [ttData]="salesSizes" ttDataId="sales_size_no" ttDataName="sales_size_name"></tt-select>
            <tt-select ttLabel="sales_possibility" [(ttModel)]="get.sales_possibility_no" [ttData]="salesPossibilities" ttDataId="sales_possibility_no" ttDataName="sales_possibility_name"></tt-select>
        </ng-container>

        <tt-select
            *ngIf="!!activityType && activityType.show_salarytype === '1'"
            ttLabel="salarytype"
            [(ttModel)]="get.salarytype_id"
            [ttData]="salaryTypes"
            ttDataId="item_id"
            ttDataName="item_name"
            ttShowClearButton
            [ttClearValue]="''"
        ></tt-select>
        <tt-checkbox *ngIf="!!activityType && activityType.show_guard === '1'" ttLabel="guard" [(ttModel)]="get.guard"></tt-checkbox>
        <tt-select ttLabel="businessco" [(ttModel)]="get.businessco_no" (ttModelChange)="onBusinessCoChanged()" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select
            *ngIf="get.show_department_id === '1'"
            ttLabel="department"
            [(ttModel)]="get.department_id"
            [ttData]="departments"
            ttDataId="department_id"
            ttDataName="department_name"
            ttShowClearButton
            [ttClearValue]="''"
        ></tt-select>
        <tt-input *ngIf="!!activityType && activityType.show_video_url === '1'" ttLabel="video_url" [(ttModel)]="get.video_url"></tt-input>
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto
            *ngIf="get.show_edit_activitytype === '1' && +get.activitytype_no > 0"
            ttText="activitytype"
            ttType="warning"
            ttGoto="activitytype"
            [ttGotoParms]="{ activitytype_no: this.get.activitytype_no }"
        ></tt-button-goto>
        <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="custactedit"></tt-button-settings>
    </tt-card>
    <tt-grid *ngIf="activityType?.show_custactproducts === '1' && !!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
